import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import * as _ from "lodash";

//constants
import { Constants }         from '../../constants/Constants';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'


@Component({
  selector: 'my-equipments-autocomplete',
  templateUrl: './EquipmentsAutoComplete.component.html'
})
export class EquipmentsAutoCompleteComponent implements OnInit {

    filteredEquipments: any[];
    selectedEquipmentNumbers: string[] = [];
    equipments: any[] = [];
    equipment: any;
    equipmentsModel: any;
    
    userInfo: ent.UserInfo;
    
    @Input() public placeholder: string;
    @Input() public multiple: boolean;
    @Output() onSelectedEquipmentNumbersChanged = new EventEmitter<string[]>();
    
    constructor(private authenticationService: serv.AuthenticationService, private EquipmentService: serv.EquipmentService) 
    { 
    }

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();
        
    }

    filterEquipments(event: any, take: number): void {
        
        
        
        // var filter: filters.EquipmentFilter = {EquipmentNameOrNumberLike: event.query, Take: take};

        // this.EquipmentService.getEquipments(filter).then(x=>{
        //     this.filteredEquipments = []
        //     for (var Equipment of x)
        //     {
        //         this.filteredEquipments.push({name: Equipment.FullName, ID: Equipment.EquipmentNumber});
        //     }
    
        // });
        
    }


    onEquipmentSelected(selectedItem: any): void {
        this.selectedEquipmentNumbers.push(selectedItem.ID);
        this.onSelectedEquipmentNumbersChanged.emit(this.selectedEquipmentNumbers);
    }

    onEquipmentUnselected(selectedItem: any): void {
        
        _.remove(this.selectedEquipmentNumbers, x=>x==selectedItem.ID);
        this.onSelectedEquipmentNumbersChanged.emit(this.selectedEquipmentNumbers);
    }

    onClearClick(event: any){
        
        this.equipments = [];
        this.equipment = new ent.Equipment();
        if (this.multiple){
            this.equipmentsModel = this.equipments;
        }
        else{
            this.equipmentsModel = this.equipment;
        }
        this.selectedEquipmentNumbers = [];
        this.onSelectedEquipmentNumbersChanged.emit(this.selectedEquipmentNumbers);
    }

}